import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// Autres modules externes utilises 

// Modules communs utilises
import { BootstrapPopupModule } from '../../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { DragDropGroupsModule } from '../../../shared/drag-drop-groups/drag-drop-groups.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../../shared/jsr310-localdates/jsr310-localdates.module';
import { MatPaginatorIntlFr } from '../../../shared/pagination/paginator-intl-fr';
import { PannelModule } from '../../../shared/pannel/pannel.module';

// Composants metiers
import { EditParcComponent } from './components/edit-parc.component';
import { EtatParcCheckboxListComponent } from './components/etat-parc-checkbox-list.component';
import { ParcFilterableSelectorComponent } from './components/parc-filterable-selector.component';
import { ParcFilterableSelectorForCcComponent } from './components/parc-filterable-selector-for-cc.component';
import { ParcMultiSelectorComponent } from './components/parc-multi-selector.component';
import { ParcCheckboxListComponent } from './components/parc-checkbox-list.component';
import { ParcSelectorComponent } from './components/parc-selector.component';
import { ParcByGroupementMultiSelectorComponent } from './components/parc-by-groupement-multi-selector.component';
import { ParcHyperviseurCheckboxListComponent } from './components/parc-hyperviseur-checkbox-list.component';
import { NotificationMeteoComponent } from './components/notif-meteo.component';

// Services metier
import { ParcService } from './services/parc.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatPaginatorModule,
		MatProgressBarModule,
		MatSortModule,
		MatTableModule,

		BootstrapPopupModule,
		CheckboxListModule,
		DragDropGroupsModule,
		FilterableSelectModule,
		PannelModule,
		JSR310LocalDatesModule
	],
	providers: [
		ParcService,
		{
			// Configuration pour que les paginators affichent des libelles en francais
			provide: MatPaginatorIntl,
			useClass: MatPaginatorIntlFr
		},
	],
	declarations: [
		EditParcComponent,
		EtatParcCheckboxListComponent,
		ParcFilterableSelectorComponent,
		ParcFilterableSelectorForCcComponent,
		ParcMultiSelectorComponent,
		ParcCheckboxListComponent,
		ParcSelectorComponent,
		ParcByGroupementMultiSelectorComponent,
		ParcHyperviseurCheckboxListComponent,		
		NotificationMeteoComponent
	],
	exports: [
		EditParcComponent,
		EtatParcCheckboxListComponent,
		ParcFilterableSelectorComponent,
		ParcFilterableSelectorForCcComponent,
		ParcMultiSelectorComponent,
		ParcCheckboxListComponent,
		ParcSelectorComponent,
		ParcByGroupementMultiSelectorComponent,
		ParcHyperviseurCheckboxListComponent,
	]
})
export class ParcModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
	.directive('editParc',
		downgradeComponent({ component: EditParcComponent })
	) //
	.service('parcsService', 
		downgradeInjectable(ParcService)
	) //
	.directive('notifMeteo',
		downgradeComponent({ component: NotificationMeteoComponent })
	) //
;